import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
/** Return the `data-` attributes from the props. */
export function getDataAttributes(props) {
  var _props$mode;
  var dataAttributes = {
    "data-mode": (_props$mode = props.mode) !== null && _props$mode !== void 0 ? _props$mode : undefined,
    "data-required": "required" in props ? props.required : undefined,
    "data-multiple-months": props.numberOfMonths && props.numberOfMonths > 1 || undefined,
    "data-week-numbers": props.showWeekNumber || undefined,
    "data-broadcast-calendar": props.broadcastCalendar || undefined
  };
  Object.entries(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    if (key.startsWith("data-")) {
      dataAttributes[key] = val;
    }
  });
  return dataAttributes;
}